import { DigitalTwinLicence } from "@iventis/domain-model/model/digitalTwinLicence";

export function createDigitalTwinUrl(digitalTwinLicence: DigitalTwinLicence) {
    const env = getEnvironment();
    const digitalTwinInstance = digitalTwinLicence.instance;
    return `https://${digitalTwinInstance?.id}.${digitalTwinInstance?.availabilityZone}.${env}.engine.iventis.com`;
}

function getEnvironment() {
    const hostName = window.location.hostname;

    if (hostName.includes(".app.") || hostName === "app.iventis.com") {
        return "app";
    }

    if (hostName.includes(".dev-zeus.")) {
        return "dev-zeus";
    }

    if (hostName.includes(".dev-anubis.")) {
        return "dev-anubis";
    }

    if (hostName.includes(".dev.") || hostName === "dev.iventis.studio") {
        return "dev";
    }

    if (hostName.includes(".staging.") || hostName === "staging.iventis.studio") {
        return "staging";
    }

    if (hostName.includes("localhost")) {
        return "dev";
    }

    throw new Error("Could not get environement");
}
